import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackEnteredFullScreen.meta';

export type EnteredFullScreenParams = {
  location?: 'pdf' | 'video';
};

export const useTrackEnteredFullScreen = () => {
  const { track } = useAnalyticsUtilities();

  const trackEnteredFullScreen = useCallback(
    (params?: EnteredFullScreenParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackEnteredFullScreen };
};
